<template>
    <div v-if="loading" class="text-center" style="margin-top: 10em">
        <div class="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
    <div v-else>
        <transition appear name="slide-fade">
            <div class="row">
                <div class="col-12">
                    <button_back></button_back>
                </div>
                <div class="col-12">
                    <h3 class="text-orange">{{ title }}</h3>
                </div>
            </div>
        </transition>
    </div>
</template>
<script lang="ts">
import { defineAsyncComponent} from 'vue';
export default {
    name: 'Usuarios_aliados',
    components:{
        button_back: defineAsyncComponent(() => import('../../../components/BackBtn.vue')),
    },
    data(){
        return{
            loading: true,
            title: null
        };
    },
    created: function (){
        this.getTitle();
    },
    methods:{
        getTitle(){
            this.title = 'Usuarios Aliados'
            this.loading = false
        }
    }
}
</script>
<style scoped>
</style>